(() => {
  const q = (sel, ctx = document) => ctx.querySelector(sel);
  const qa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const overlay = q('[data-overlay]');
  const cartDrawer = q('[data-cart-drawer]');
  const mobileMenu = q('[data-mobile-menu]');

  function openPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-visible');
  }
  function closePanels() {
    [cartDrawer, mobileMenu].forEach(panel => {
      panel?.classList.remove('is-open');
      panel?.setAttribute('aria-hidden', 'true');
    });
    overlay?.classList.remove('is-visible');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) openPanel(cartDrawer);
    if (e.target.closest('[data-cart-close], [data-menu-close]')) closePanels();
    if (e.target.closest('[data-menu-open]')) openPanel(mobileMenu);
    if (e.target === overlay) closePanels();

    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const wrap = e.target.closest('.bz-qty');
      const input = q('[data-qty-input]', wrap);
      if (!input) return;
      const value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
      input.value = value;
    }

    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      updateLine(Number(remove.dataset.removeLine), 0);
    }
  });

  qa('.bz-mobile-menu a').forEach(a => a.addEventListener('click', closePanels));

  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-variant-select]')) return;
    const option = e.target.selectedOptions[0];
    const section = e.target.closest('[data-product-section]');
    const priceNode = q('[data-product-price]', section);
    if (priceNode && option?.dataset.price) {
      priceNode.textContent = formatMoney(Number(option.dataset.price), window.Shopify?.currency?.active || 'CHF');
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.bz-product-form');
    if (!form) return;
    e.preventDefault();
    const button = q('button[type="submit"]', form);
    try {
      if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
      const response = await fetch(window.BZ57.cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Could not add product');
      await refreshCart();
      openPanel(cartDrawer);
    } catch (err) {
      console.error(err);
      alert('Could not add this item to the bag. Please try again.');
    } finally {
      if (button) { button.disabled = false; button.textContent = 'ADD TO BAG'; }
    }
  });

  async function updateLine(line, quantity) {
    try {
      await fetch(`${window.BZ57.cartPageUrl}/change.js`, {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ line, quantity })
      });
      await refreshCart();
    } catch (err) { console.error(err); }
  }

  async function refreshCart() {
    const response = await fetch(window.BZ57.cartUrl, {headers:{'Accept':'application/json'}});
    const cart = await response.json();
    qa('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    const body = q('[data-cart-body]');
    const footer = q('[data-cart-footer]');
    const subtotal = q('[data-cart-subtotal]');
    if (!body || !footer) return;

    if (!cart.item_count) {
      body.innerHTML = '<p class="bz-empty-state">YOUR BAG IS EMPTY.</p>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map((item, index) => `
      <div class="bz-cart-item">
        <a class="bz-cart-thumb" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : 'BZ57'}</a>
        <div>
          <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <p>QTY ${item.quantity}</p>
          <p>${formatMoney(item.final_line_price, cart.currency)}</p>
          <button class="bz-remove-button" type="button" data-remove-line="${index + 1}">REMOVE</button>
        </div>
      </div>`).join('');
    footer.hidden = false;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
  }

  function formatMoney(cents, currency = 'CHF') {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
    } catch (_) { return `${currency} ${(cents / 100).toFixed(2)}`; }
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[ch]));
  }
})();